// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Nacogdoches from '../../../Texas/data/counties/Nacogdoches.geo.json'
import San_Augustine from '../../../Texas/data/counties/San_Augustine.geo.json'
import Sabine from '../../../Texas/data/counties/Sabine.geo.json'
import Angelina from '../../../Texas/data/counties/Angelina.geo.json'
import San_Jacinto from '../../../Texas/data/counties/San_Jacinto.geo.json'
import Polk from '../../../Texas/data/counties/Polk.geo.json'
import Tyler from '../../../Texas/data/counties/Tyler.geo.json'

const counties = {
  Nacogdoches,
  San_Augustine,
  Sabine,
  Angelina,
  San_Jacinto,
  Polk,
  Tyler
}

export default counties
